import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/supplier-payments')({
  staticData: { crumb: 'supplierPayments' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'purchasing.read'),
  component: Outlet,
})
